import {
  LIST_PROJECTS_ERROR,
  LIST_PROJECTS_START,
  LIST_PROJECTS_SUCCESS,
} from 'constants/action-types/projects/listProjects';

export default (state, { type, payload }) => {
  switch (type) {
    case LIST_PROJECTS_START:
      return {
        ...state,
        list: {
          ...state.list,
          loading: true,
          error: null,
        },
      };
    case LIST_PROJECTS_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          error: payload,
          loading: false,
        },
      };
    case LIST_PROJECTS_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          items: payload.data,
          meta: payload.meta,
          loading: false,
        },
      };
    default:
      return null;
  }
};
